import { render, staticRenderFns } from "./DiscountTag.vue?vue&type=template&id=3c8ff5ee&scoped=true"
import script from "./DiscountTag.vue?vue&type=script&lang=js"
export * from "./DiscountTag.vue?vue&type=script&lang=js"
import style0 from "./DiscountTag.vue?vue&type=style&index=0&id=3c8ff5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8ff5ee",
  null
  
)

export default component.exports